var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70711 7.70711C1.31658 8.09763 0.683417 8.09763 0.292893 7.70711C-0.0976317 7.31658 -0.0976317 6.68342 0.292893 6.29289L6.29289 0.292895C6.67147 -0.0856838 7.28106 -0.0989294 7.67572 0.262848L13.6757 5.76285C14.0828 6.13604 14.1103 6.76861 13.7372 7.17573C13.364 7.58285 12.7314 7.61035 12.3243 7.23716L7.03008 2.38414L1.70711 7.70711Z",
    fill: "#B9D3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.29fe0c8a7c57f3cbcd70df59b194705d.svg";
export { ForwardRef as ReactComponent };